module.exports = __webpack_public_path__ + "static/img/香港CI.479a4cdc.jpg";